<template>
  <standard-dialog
    v-model="model"
    :title="restaurant?.name"
    icon="mdi-information"
    max-width="600"
    hide-actions
  >
    <div v-if="restaurant">
      <v-row>
        <!-- Address -->
        <v-col cols="12" v-if="restaurant.address">
          <div class="d-flex align-center">
            <v-icon color="primary" class="mr-2">mdi-map-marker</v-icon>
            <div>
              <div class="text-caption text--secondary">{{ $t("address") }}</div>
              <div>{{ toLatin(restaurant.address) }}</div>
            </div>
          </div>
        </v-col>

        <!-- Phone -->
        <v-col cols="12" md="6" v-if="restaurant.phone">
          <div class="d-flex align-center">
            <v-icon color="primary" class="mr-2">mdi-phone</v-icon>
            <div>
              <div class="text-caption text--secondary">{{ $t("phone") }}</div>
              <div>{{ restaurant.phone }}</div>
            </div>
          </div>
        </v-col>

        <!-- Email -->
        <v-col cols="12" md="6" v-if="restaurant.email">
          <div class="d-flex align-center">
            <v-icon color="primary" class="mr-2">mdi-email</v-icon>
            <div>
              <div class="text-caption text--secondary">Email</div>
              <div>{{ restaurant.email }}</div>
            </div>
          </div>
        </v-col>

        <!-- Owner -->
        <v-col cols="12" v-if="restaurant.owner">
          <div class="d-flex align-center">
            <v-icon color="primary" class="mr-2">mdi-account</v-icon>
            <div>
              <div class="text-caption text--secondary">{{ $t("owner") }}</div>
              <div>{{ restaurant.owner }}</div>
            </div>
          </div>
        </v-col>

        <!-- Contact Person -->
        <v-col cols="12" v-if="restaurant.contact_person">
          <div class="d-flex align-center">
            <v-icon color="primary" class="mr-2">mdi-account-tie</v-icon>
            <div>
              <div class="text-caption text--secondary">{{ $t("contact_person") }}</div>
              <div>{{ restaurant.contact_person }}</div>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
  </standard-dialog>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import StandardDialog from "@/components/dialogs/StandardDialog.vue";
export default {
  name: "RestaurantContactDialog",
  components: {
    StandardDialog,
  },
  mixins: [hasModel],
  props: {
    restaurant: {
      type: Object,
      default: null,
    },
  },
  computed: {
    hasSocialLinks() {
      return this.restaurant?.fb || this.restaurant?.instagram || this.restaurant?.url;
    },
    hasAppLinks() {
      return (
        this.restaurant?.settings?.google ||
        this.restaurant?.settings?.apple ||
        this.restaurant?.settings?.huawei
      );
    },
  },
};
</script>
